import React, { useState, useEffect } from 'react';
import { removeAuth } from '../features/auth/authSlice';
import { toast } from 'react-toastify';
import { useAppDispatch } from '../Hooks';
import { AuthContext, AuthProviderProps, User } from '../types/provider/authProviderType';

export const AuthProvider: React.FC<AuthProviderProps> = ({ children }) => {
    const dispatch = useAppDispatch();
    const [user, setUser] = useState<User | null>(() => {
        const savedUser = localStorage.getItem('user');
        return savedUser ? JSON.parse(savedUser) : null;
    });

    const login = (userData: User) => {
        localStorage.setItem('user', JSON.stringify(userData));
        localStorage.setItem('token', userData.token);
        setUser(userData);
    };

    const logout = () => {
        localStorage.clear();
        setUser(null);
        dispatch(removeAuth());
        toast.success("Logout successfully");
    };

    useEffect(() => {
        const savedUser = localStorage.getItem('user');
        const parsedUser = savedUser ? JSON.parse(savedUser) : null;
        if (!user) {
            setUser(parsedUser);
        }
    }, [user]);

    return (
        <AuthContext.Provider value={{ user, login, logout }}>
            {children}
        </AuthContext.Provider>
    );
};


